module.exports = function() {
  return new Worker(__webpack_public_path__ + "b653595f8aae2f84cec4.worker.js");
};